import React, { useEffect, Dispatch, SetStateAction } from "react"
import "twin.macro"
import { useTranslation } from "next-i18next"
import animationData from "../../assets/dashboard/wave.json"
import { LottieAnimation } from "../lottieAnimation"
import { AskQuestionStep } from "."

interface PreparingProp {
  setStep: Dispatch<SetStateAction<AskQuestionStep>>
}
export const Preparing = ({ setStep }: PreparingProp) => {
  const { t } = useTranslation("profile")
  useEffect(() => {
    setTimeout(() => setStep?.(AskQuestionStep.Payment), 2000)
  }, [])

  return (
    <div tw="space-y-12" data-testid="preparing">
      <div tw="space-y-3 min-h-mobile-lg flex flex-col items-center justify-center">
        <div>
          <h3 tw="text-lg text-center">{t("ask_question.preparing")}</h3>
          <LottieAnimation data-chromatic="ignore" width="234px" height="auto" animationData={animationData} />
        </div>
      </div>
    </div>
  )
}
